module.exports = __webpack_public_path__ + "static/crecimiento-6de8af8d416130059fd8df75ff83037b.svg";